import Swal from "sweetalert2";
import { benamingKlachten } from "../klantenregister";
import { AXIOS_POST, AXIOS_UPDATE } from "../server/api/crud";

const updateKlachten = (categoryKey, itemKey, newValue, setKlachten) => {
  setKlachten((prevState) => ({
    ...prevState,
    [categoryKey]: {
      ...prevState[categoryKey],
      [itemKey]: newValue,
    },
  }));
};

const isOkStatus = (status) => status >= 200 && status < 300;

export const versturenKlachten = async (klacht, setOpen) => {
  if (!klacht?.id) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Geen klachtenregister gevonden om te verzenden.",
      showConfirmButton: true,
    });
    return false;
  }
  try {
    const verstuur = { versturen: 1 };
    const res = await AXIOS_UPDATE(
      `klachtenregistratie/versturen`,
      klacht.id,
      verstuur
    );
    if (isOkStatus(res.status)) {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Uw klachtenformulier is verstuurd",
        showConfirmButton: false,
        timer: 2500,
      });
      setOpen(false);
      return true;
    }
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: "Versturen is mislukt. Probeer later opnieuw.",
      showConfirmButton: false,
      timer: 2500,
    });
    return false;
  } catch (error) {
    console.error("versturenKlachten:", error);
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Versturen is mislukt. Controleer uw verbinding en probeer opnieuw.",
      showConfirmButton: true,
    });
    return false;
  }
};

/**
 * Slaat de huidige categorie op (POST eerste keer, PATCH bij bestaande rij).
 * @returns {Promise<boolean>} true bij succesvolle server-response
 */
export const opslaanKlachten = async (
  klacht,
  selectKlacht,
  setStates,
  categorie,
  setKlachten,
  setExtra
) => {
  const meta = benamingKlachten[selectKlacht];
  if (!meta || !klacht?.id || !categorie) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Ongeldige gegevens om op te slaan.",
      showConfirmButton: true,
    });
    return false;
  }

  try {
    const sameRow =
      categorie.klachtr_id != null &&
      Number(categorie.klachtr_id) === Number(klacht.id);

    if (sameRow) {
      const respons = await AXIOS_UPDATE(
        `klachtenregistratie/${meta.link}`,
        klacht.id,
        {
          [meta.key]: categorie,
          klachtenregister: klacht,
        }
      );
      if (!isOkStatus(respons.status)) {
        throw new Error(`Unexpected status ${respons.status}`);
      }
      if (meta.id <= 16) {
        updateKlachten(meta.key, "klachtr_id", klacht?.id, setKlachten);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: `Categorie ${meta.title} is gewijzigd`,
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        Swal.fire(
          "De klachtenregistratie is volledig gewijzigd",
          "",
          "success"
        );
        setExtra(1);
      }
      return true;
    }

    const payload = {
      ...categorie,
      klachtr_id: klacht.id,
    };
    const res = await AXIOS_POST(
      `klachtenregistratie/${meta.link}/${klacht.id}`,
      {
        [meta.key]: payload,
        klachtenregister: klacht,
      }
    );
    if (!isOkStatus(res.status)) {
      throw new Error(`Unexpected status ${res.status}`);
    }
    if (meta.id <= 16) {
      setStates({ id: meta.id + 1 });
      updateKlachten(meta.key, "klachtr_id", klacht?.id, setKlachten);
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: `Categorie ${meta.title} is ingevuld`,
        showConfirmButton: false,
        timer: 2500,
      });
    } else {
      Swal.fire(
        "De klachtenregistratie is volledig ingevuld",
        "",
        "success"
      );
      setExtra(1);
    }
    return true;
  } catch (error) {
    console.error("opslaanKlachten:", error);
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Opslaan van ${benamingKlachten[selectKlacht]?.title || "categorie"} is mislukt.`,
      showConfirmButton: false,
      timer: 2500,
    });
    return false;
  }
};

/**
 * @returns {Promise<boolean>}
 */
export const opslaanOpmerkingKlachten = async (
  klacht,
  selectKlacht,
  setStates,
  categorie,
  admin,
  setOpen
) => {
  const meta = benamingKlachten[selectKlacht];
  if (!meta || !categorie?.klachtr_id) {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Ongeldige gegevens om op te slaan.",
      showConfirmButton: true,
    });
    return false;
  }

  try {
    const body = {
      ...categorie,
      admin_id: admin?.id,
    };
    const respons = await AXIOS_UPDATE(
      `klachtenregistratie/${meta.link}/admin`,
      categorie.klachtr_id,
      {
        [meta.key]: body,
        klachtenregister: klacht,
      }
    );
    if (!isOkStatus(respons.status)) {
      throw new Error(`Unexpected status ${respons.status}`);
    }
    setStates({ id: meta.id + 1 });
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Uw opmerking is opgeslagen",
      showConfirmButton: false,
      timer: 1500,
    });
    if (meta.id > 16) {
      setOpen(false);
    }
    return true;
  } catch (error) {
    console.error("opslaanOpmerkingKlachten:", error);
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Opslaan van ${benamingKlachten[selectKlacht]?.title || "categorie"} is mislukt.`,
      showConfirmButton: false,
      timer: 2500,
    });
    return false;
  }
};
